

export const types = {

    uiOpenModal : '[ui] Open Modal',
    uiCloseModal : '[ui] Close Modal',
    uiOpenSuccesM: '[ui] Open Success Menssage',
    uiCloseSuccesM: '[ui] Close Success Menssage',
    startLoading: '[ui] start load content',
    endLoading: '[ui] end load content',

    eventStartAddNew: '[event] Start add new',
    eventSetActive: '[event] Set Active',
    eventAddNew: '[event] Add new',
    eventUpdated: '[event] Event Updated',
    cleanActiveNote: '[event] Clean ActiveNote',
    eventDeleted: '[event] Event Deleted',
    eventLoaded: '[event] Events loaded',
    eventLogout: '[event] Event Loout',

    authCheckingFinish: '[auth] finish login state',
    authStartLogin: '[auth] Start login',
    authLogin: '[auth] Login',
    authRegister: '[auth] Register',
    authStartRegister: '[auth] Start register',
    authStartTokenRenew: '[auth] Start token renew',
    authLogout: '[auth] Logout',

} 